// Load only the animation requested by the component.
export const animatedIconLoaders = {
  alert: () => import("../../assets/animated/alert.json"),
  "api-error": () => import("../../assets/animated/api-error.json"),
  combined: () => import("../../assets/animated/combined.json"),
  connect: () => import("../../assets/animated/connect.json"),
  copy: () => import("../../assets/animated/copy.json"),
  deposit: () => import("../../assets/animated/deposit.json"),
  deposited: () => import("../../assets/animated/deposited.json"),
  disconnect: () => import("../../assets/animated/disconnect.json"),
  download: () => import("../../assets/animated/download.json"),
  exclamation: () => import("../../assets/animated/exclamation.json"),
  external: () => import("../../assets/animated/external.json"),
  filters: () => import("../../assets/animated/filters.json"),
  locked: () => import("../../assets/animated/locked.json"),
  network: () => import("../../assets/animated/network.json"),
  notification: () => import("../../assets/animated/notification.json"),
  portfolio: () => import("../../assets/animated/portfolio.json"),
  settings: () => import("../../assets/animated/settings.json"),
  "shield-check": () => import("../../assets/animated/shield-check.json"),
  "shield-error": () => import("../../assets/animated/shield-error.json"),
  sign: () => import("../../assets/animated/sign.json"),
  "signing-failed": () => import("../../assets/animated/signing-failed.json"),
  "signing-success": () => import("../../assets/animated/signing-success.json"),
  spinner: () => import("../../assets/animated/spinner.json"),
  stacked: () => import("../../assets/animated/stacked.json"),
  swap: () => import("../../assets/animated/swap.json"),
  "swap-circle": () => import("../../assets/animated/swap-circle.json"),
  "tx-fail": () => import("../../assets/animated/tx-fail.json"),
  "tx-sign": () => import("../../assets/animated/tx-sign.json"),
  "tx-simulate": () => import("../../assets/animated/tx-simulate.json"),
  "tx-success": () => import("../../assets/animated/tx-success.json"),
  unlock: () => import("../../assets/animated/unlock.json"),
  unlocked: () => import("../../assets/animated/unlocked.json"),
  vault: () => import("../../assets/animated/vault.json"),
} as const;

export type AnimatedIconName = keyof typeof animatedIconLoaders;

export const animatedIconNames = Object.keys(
  animatedIconLoaders
) as AnimatedIconName[];
